var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.layoutDevice,attrs:{"id":"app"}},[(!_vm.inShell)?_c('SiteHeader'):_vm._e(),_c('router-view'),(!_vm.inShell)?_c('SiteFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }